import TryoutMembers from "@/modules/tryout_members/components/TryoutMembers";
import TryoutMembersDetail from "@/modules/tryout_members/components/TryoutMembersDetail";
import TryoutMembersList from "@/modules/tryout_members/components/TryoutMembersList";

export default [
    {
        path: "/tryout-members",
        name: "TryoutMembers",
        component: TryoutMembers,
    },
    {
        path: "/tryout-members/:id",
        name: "TryoutMembersList",
        component: TryoutMembersList,
    },
    {
        path: "/tryout-members-detail/:idgroup/:idtryout",
        name: "TryoutMembersDetail",
        component: TryoutMembersDetail,
    },
];



// WEBPACK FOOTER //
// ./src/modules/tryout_members/router/tryout_members.js